import { isArray, isString, map } from 'lodash';
import React from 'react';
import AuthError from 'sections/auth/Error';

import Text from '@skippay/core/components/Text';

function AuthErrors(props: {
	errors: string | Array<string | { message: string }>;
}): React.JSX.Element | null {
	const { errors } = props;

	return (isArray(errors) && !errors.length) || !errors ? null : (
		<>
			{isArray(errors) ? (
				map(errors, (error, idx) => (
					<AuthError key={idx}>
						<Text as="strong">{isString(error) ? error : error.message}</Text>
					</AuthError>
				))
			) : (
				<AuthError>
					<Text as="strong">{errors}</Text>
				</AuthError>
			)}
		</>
	);
}

export default AuthErrors;
